import axiosInstance from "../api/apiClient";
import { getUserSession } from "../function/AuthStorage";

/** معرّف المستخدم الحالي (جلسة الدخول تحفظه في «id»). */
export const myUserId = () => { const u = getUserSession(); return u?.id || u?.userId || null; };

/**
 * تحديث 59 — واجهة مركز التواصل والتعاميم (api/comm). الصلاحيات وعزل المشروعات في الخادم.
 * القوائم بترقيم خادمي: pageNumber / pageSize / search + فلاتر بأسمائها.
 */
const data = (p) => p.then((r) => r.data);
const clean = (o) => Object.fromEntries(Object.entries(o || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined));

export const errorText = (err, fallback = "تعذّر تنفيذ العملية.") =>
  err?.response?.data?.message || err?.response?.data?.title || (err?.response?.status === 403 ? "لا تملك الصلاحية." : null) || err?.message || fallback;

// ───── عام ─────
export const fetchContracts = () => data(axiosInstance.get("comm/contracts"));
export const fetchSummary = () => data(axiosInstance.get("comm/summary"));
export const fetchDirectory = (contractId) => data(axiosInstance.get(`comm/directory/${contractId}`));
export const fetchActivity = (params) => data(axiosInstance.get("comm/activity", { params: clean(params) }));

// ───── الغرف ─────
export const fetchRooms = (params) => data(axiosInstance.get("comm/rooms", { params: clean(params) }));
export const fetchRoom = (id) => data(axiosInstance.get(`comm/rooms/${id}`));
export const createRoom = (body) => data(axiosInstance.post("comm/rooms", body));
export const updateRoom = (id, body) => data(axiosInstance.put(`comm/rooms/${id}`, body));
export const fetchMembers = (id) => data(axiosInstance.get(`comm/rooms/${id}/members`));
export const addMembers = (id, body) => data(axiosInstance.post(`comm/rooms/${id}/members`, body));
export const removeMember = (id, userId) => data(axiosInstance.delete(`comm/rooms/${id}/members/${encodeURIComponent(userId)}`));
export const archiveRoom = (id, archive = true) => data(axiosInstance.post(`comm/rooms/${id}/archive`, {}, { params: { archive } }));
export const lookupWorkOrders = (contractId, search) => data(axiosInstance.get("comm/work-orders", { params: clean({ contractId, search }) }));
export const openWorkOrderRoom = (type, workOrderId) => data(axiosInstance.post("comm/rooms/work-order", { type, workOrderId }));

// ───── الرسائل ─────
export const fetchMessages = (roomId, params) => data(axiosInstance.get(`comm/rooms/${roomId}/messages`, { params: clean(params) }));
export const sendMessage = (roomId, { body, replyToId, workOrderType, workOrderId, files }) => {
  const fd = new FormData();
  fd.append("body", body || "");
  if (replyToId) fd.append("replyToId", replyToId);
  if (workOrderId) { fd.append("workOrderType", workOrderType); fd.append("workOrderId", workOrderId); }
  (files || []).forEach((f) => fd.append("files", f));
  return data(axiosInstance.post(`comm/rooms/${roomId}/messages`, fd, { headers: { "Content-Type": "multipart/form-data" } }));
};
export const editMessage = (id, body) => data(axiosInstance.put(`comm/messages/${id}`, { body }));
export const deleteMessage = (id) => data(axiosInstance.delete(`comm/messages/${id}`));
export const markRead = (roomId, upToId) => data(axiosInstance.post(`comm/rooms/${roomId}/read`, { upToId }));
export const searchMessages = (params) => data(axiosInstance.get("comm/messages/search", { params: clean(params) }));

/** المرفقات تمر عبر الخادم (تحقق الصلاحية) — تُجلب كـ Blob ثم تُفتح أو تُنزَّل. */
export async function openAttachment(att, download = false) {
  const r = await axiosInstance.get(`comm/attachments/${att.id}`, { params: { inline: !download }, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  if (download || !att.previewable) {
    const a = document.createElement("a");
    a.href = url; a.download = att.fileName || "file"; document.body.appendChild(a); a.click(); a.remove();
  } else window.open(url, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// ───── التعاميم ─────
export const fetchCirculars = (params) => data(axiosInstance.get("comm/circulars", { params: clean(params) }));
export const fetchCircular = (id) => data(axiosInstance.get(`comm/circulars/${id}`));
export const publishCircular = (input, files) => {
  const fd = new FormData();
  Object.entries(input).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (Array.isArray(v)) v.forEach((x) => fd.append(k, x));
    else fd.append(k, typeof v === "boolean" ? String(v) : v);
  });
  (files || []).forEach((f) => fd.append("files", f));
  return data(axiosInstance.post("comm/circulars", fd, { headers: { "Content-Type": "multipart/form-data" } }));
};
export const acknowledge = (id, note) => data(axiosInstance.post(`comm/circulars/${id}/ack`, { note }));
export const archiveCircular = (id, archive = true) => data(axiosInstance.post(`comm/circulars/${id}/archive`, {}, { params: { archive } }));
export const fetchRecipients = (id, params) => data(axiosInstance.get(`comm/circulars/${id}/recipients`, { params: clean(params) }));
export async function exportRecipients(id, number, status) {
  const r = await axiosInstance.get(`comm/circulars/${id}/recipients/export`, { params: clean({ status }), responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = `${number || "circular"}-recipients.xlsx`; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const newRequestKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`).replace(/-/g, "");

export const fmtSize = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} م.ب` : `${Math.max(1, Math.round(n / 1024))} ك.ب`);
export const fmtTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date();
  const same = d.toDateString() === today.toDateString();
  return same ? d.toLocaleTimeString("ar-SA-u-nu-latn", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleString("ar-SA-u-nu-latn", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
};
